import React from "react";
import { Grid, Paper, Box, Typography, Chip } from "@mui/material";

import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined";

function StatusCard({ title, value, subtitle, icon, tone = "default" }) {
  const toneMap = {
    default: { bg: "rgba(33,49,89,0.10)", color: "var(--cise-blue)" },
    success: { bg: "rgba(22,163,74,0.10)", color: "var(--cise-success)" },
    warning: { bg: "rgba(245,158,11,0.12)", color: "var(--cise-warning)" },
    danger: { bg: "rgba(239,68,68,0.10)", color: "var(--cise-error)" },
  };
  const t = toneMap[tone] || toneMap.default;

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: 2,
        border: "1px solid var(--border)",
        bgcolor: "var(--branco)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        minHeight: 92,
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography sx={{ fontSize: 12, fontWeight: 900, color: "var(--cise-text-muted)" }}>
          {title}
        </Typography>
        <Typography sx={{ fontSize: 22, fontWeight: 900, color: "var(--cise-text)", lineHeight: 1.15 }}>
          {value}
        </Typography>
        {subtitle && (
          <Typography sx={{ fontSize: 12.5, color: "var(--cise-text-muted)", mt: 0.25 }} noWrap>
            {subtitle}
          </Typography>
        )}
      </Box>

      <Box
        sx={{
          width: 44,
          height: 44,
          borderRadius: 2,
          display: "grid",
          placeItems: "center",
          bgcolor: t.bg,
          color: t.color,
          flexShrink: 0,
        }}
      >
        {icon}
      </Box>
    </Paper>
  );
}

export default function SettingsTopCards() {
  // mock status (depois você pluga no Firebase)
  const whatsappStatus = "Conectado";
  const aiStatus = "Ativa";
  const activeUsers = 6;
  const sla = "10 min";

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3}>
        <StatusCard
          title="WhatsApp"
          value={whatsappStatus}
          subtitle="Cloud API"
          icon={<WhatsAppIcon />}
          tone="success"
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <StatusCard
          title="IA"
          value={aiStatus}
          subtitle="Respostas assistidas"
          icon={<AutoAwesomeOutlinedIcon />}
          tone="default"
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <StatusCard
          title="Usuários ativos"
          value={activeUsers}
          subtitle="perfis SDR/Admin"
          icon={<GroupOutlinedIcon />}
          tone="default"
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <StatusCard
          title="SLA de resposta"
          value={sla}
          subtitle="meta operacional"
          icon={<TimerOutlinedIcon />}
          tone="warning"
        />
      </Grid>
    </Grid>
  );
}
